export const CHROME_APP_WEBSTORE_URL =
  'https://chrome.google.com/webstore/detail/codeorg-serial-connector/ncmmhcpckfejllekofcacodljhdhibkg';

export const MAKER_DEPRECATION_SUPPORT_URL =
  'https://support.code.org/hc/en-us/articles/11304760762125';

export const MAKER_TOOLKIT = 'maker-toolkit';

export const DOWNLOAD_PREFIX = 'https://downloads.code.org/maker/';
